export { MotionValue } from './MotionValue.es.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/types/dist/index.es.js
// module id = /MBf
// module chunks = 0